import useAppView from 'Core/Hooks/useAppView'
import useMultiSlice from 'Core/Hooks/useMultiSlice'
import { useUser } from 'Core/Hooks/useUser'
import { cn } from 'Utils/Helpers'
import { getAccountIcon } from 'Utils/PureHelperFuctions'
import { LabelContent } from 'V2Components'
import {
  AppBackendURLKey,
  AppFrontendURLKey,
  AppHTTPEntryPathKey,
  AppMeshClusterKey,
  AppSSOURLKey,
  AppServiceProviderMetadatKey,
  getApplicationType,
  useAppDetailsContext,
  McpAuthTokenKey,
  McpBackendURLKey,
  McpFrontendURLKey,
  McpHTTPEntryPathKey,
  McpMeshClusterKey,
  WithTooltip,
} from 'features/applications'
import { getResourceName, getResourcePolicyTags, getRsrcIcon } from 'features/resources'
import { reduxApiClient } from 'infra'

import { createDataSelectorHook } from 'infra/redux'
import { getHTMLDataTestID } from 'infra/utils'
import _ from 'lodash'
import moment from 'moment'
import { InformationRow, Label, RiskIndicator, Typography, TextInput } from 'procyon-ui'
import React, { useEffect, useState } from 'react'
const useSlices = createDataSelectorHook([
  'githubAccount',
  'githubResources',
  'salesForceAccountList'
])

function OverviewTab() {
  const { app } = useAppDetailsContext()
  const { user, rdpurl, isAgentlessMode } = useUser()
  const { appView } = useAppView()
  const appType = getApplicationType(app)
  const { getObjectRef } = useMultiSlice(['accountList'])
  const Icon = getRsrcIcon(app)
  const account = getObjectRef(app?.Spec.Account)
  const AccountIcon = getAccountIcon(account?.Spec.Type)
  const [repoCount, setRepoCount] = useState(Number)
  const [sFedittion, setSFedittion] = useState('')
  const { slices } = useSlices()

  useEffect(() => {
    if (app.Spec.AppType === 'github') {
      RepoCount()
    }
    if (app.Spec.AppType === 'salesforce') {
      getSfAccountEdition(app)
    }
  }, [])

  const getSfAccountEdition = async (app) => {
    try {
      const accountList = await reduxApiClient('salesforce-account').getAll()
      const filterCurrentAccount = await accountList?.find(
        (account) => account.Application.RefID === app.ObjectMeta.ID
      )
      setSFedittion(filterCurrentAccount?.Spec.Edition)
    } catch (e) {
      console.log(e)
    }
  }

  const RepoCount = async () => {
    const currentAccount = _.find(slices.githubAccount, {
      Application: { RefID: app?.ObjectMeta?.ID }
    })
    const currentUserWithWriteAccess = currentAccount?.ObjectMeta?.WrOwners?.ObjectRef?.find(
      (member) => member?.RefID === user?.ObjectMeta?.ID
    )

    let filterRepoCard = []

    if (appView === 'user') {
      const currentUserAccess = await currentAccount?.Spec?.Members?.Members?.find(
        (member) => member?.memberRef?.RefID === user?.ObjectMeta?.ID
      )

      if (
        (currentUserAccess?.ScimProvisonedIdentity || currentUserWithWriteAccess) &&
        slices.githubResources
      ) {
        filterRepoCard = slices.githubResources.filter(
          (obj) =>
            obj.Spec.Type === 'repository' &&
            obj.Spec.Account.RefID === currentAccount?.ObjectMeta?.ID
        )
      }
    } else if (slices.githubResources) {
      filterRepoCard = slices.githubResources.filter(
        (obj) =>
          obj.Spec.Type === 'repository' &&
          obj.Spec.Account.RefID === currentAccount?.ObjectMeta?.ID
      )
    }
    setRepoCount(filterRepoCard.length)
  }

  const getFnUrlWithAgentLessCheck = () => {
    let url = appType === 'MCP' ? _.get(app, McpFrontendURLKey) : _.get(app, AppFrontendURLKey)
    if (isAgentlessMode) {
      return url.replace('.default', '-app-default').replace('.procyon.ai', `.${rdpurl}`)
    } else {
      return url
    }
  }

  const generateToolsLable = (app, type) => {
    const { McpPrommpts, McpTools } = app.Status.McpServerStatus;
  
    if (type === "tools" && McpTools) {
      if (McpTools?.length === 0) {
        return <div className="mt-2 text-sm text-gray-500">Emtpy Tools</div>;
      }
  
      let parsed = [];
      try {
        parsed = JSON.parse(McpTools);
      } catch {
        return <div className="mt-2 text-sm text-red-500">Invalid tools JSON</div>;
      }
  
      return (
        <div className="flex flex-wrap gap-2 mt-2">
          {parsed.map((t, i) => (
            <WithTooltip
              key={i}
              id={`tool-tip-${i}`}
              content={`Description: ${t?.description ?? "—"}`}
            >
              <Label variant='grayBlue' text={t?.name ?? "Unnamed"} />
            </WithTooltip>
          ))}
        </div>
      );
    }
  
    if (type === "prompts" && McpPrommpts) {
      if (McpPrommpts?.length === 0) {
        return <div className="mt-2 text-sm text-gray-500">Emtpy Prompts</div>;
      }
  
      let parsed = [];
      try {
        parsed = JSON.parse(McpPrommpts);
      } catch {
        return <div className="mt-2 text-sm text-red-500">Invalid prompts JSON</div>;
      }
  
      return (
        <div className="flex flex-wrap gap-2 mt-2">
          {parsed.map((t, i) => (
            <WithTooltip
              key={i}
              id={`prompt-tip-${i}`}
              content={`Description: ${t?.description ?? "—"}`}
            >
              <Label variant='grayBlue' text={t?.name ?? "Unnamed"} />
            </WithTooltip>
          ))}
        </div>
      );
    }
  
    return null;
  };
  
  
    const getHeadersMap = (app) => {
      const headers = app?.Spec?.McpAppConfig?.Headers?.Map || {}
      const entries = Object.entries(headers)
  
      if (entries.length === 0) {
        return <div className='mt-2 text-sm text-gray-500'>No headers configured.</div>
      }
  
      return entries.map(([hdrKey, hdrVal]) => (
        <div key={hdrKey} className='flex gap-4 mt-2 items-center'>
          <div className='flex items-center gap-2'>
            <Typography variant='body-regular'>Key</Typography>
            <TextInput placeholder='key' value={hdrKey} disabled />
          </div>
  
          <div className='flex items-center gap-2'>
            <Typography variant='body-regular'>Value</Typography>
            <TextInput placeholder='value' value={String(hdrVal ?? '')} disabled />
          </div>
        </div>
      ))
    }

  const policyTags = Object.values(getResourcePolicyTags(app))

  return (
    <div className='flex gap-8'>
      <div className={cn('pr-8 w-1/2 border-[#D8DDE4] border-r')}>
        <Typography variant='h4-regular'>Resource Information</Typography>
        <div className='mt-8'>
          <LabelContent
            data-testid={getHTMLDataTestID('app-details', 'label', 'app-name')}
            title='Application Name'
            content={getResourceName(app)}
          />
          <LabelContent
            data-testid={getHTMLDataTestID('app-details', 'label', 'app-type')}
            title='Application Type'
            content={
              <Label
                //@ts-ignore
                text={
                  <div className='flex items-center'>
                    {Icon && <Icon />}
                    <strong>{appType}</strong>
                  </div>
                }
              />
            }
          />
          {account && (
            <LabelContent
              data-testid={getHTMLDataTestID('app-details', 'label', 'app-account')}
              title='Account'
              content={
                <div className='flex gap-2 items-center'>
                  {AccountIcon && <AccountIcon />}
                  {getResourceName(account)}
                </div>
              }
            />
          )}
          {getApplicationType(app) === 'HTTP' && (
            <>
              <LabelContent
                data-testid={getHTMLDataTestID('app-details', 'label', 'frontend-name')}
                title='Frontend Name'
                content={<Label className='!normal-case' text={getFnUrlWithAgentLessCheck()} />}
              />
              <LabelContent
                data-testid={getHTMLDataTestID('app-details', 'label', 'frontend-url')}
                title='Frontend URL path'
                content={_.get(app, AppHTTPEntryPathKey, '/')}
              />
              <LabelContent
                data-testid={getHTMLDataTestID('app-details', 'label', 'backend-name')}
                title='Backend Name'
                content={<Label className='!normal-case' text={_.get(app, AppBackendURLKey)} />}
              />
              <LabelContent
                data-testid={getHTMLDataTestID('app-details', 'label', 'mesh-cluster')}
                title='Mesh Cluster'
                content={<Label className='!normal-case' text={_.get(app, AppMeshClusterKey)} />}
              />
            </>
          )}
          {getApplicationType(app) === 'AWS' && (
            <>
              <LabelContent
                data-testid={getHTMLDataTestID('app-details', 'label', 'aws-account-id')}
                title='AWS Account ID'
                content={_.get(app, 'Spec.AwsFederationConfig.AwsAccountID')}
              />
              <LabelContent
                data-testid={getHTMLDataTestID('app-details', 'label', 'aws-idprovider-arn')}
                title='AWS IDProvider ARN'
                content={_.get(app, 'Spec.AwsFederationConfig.AwsIdproviderARN')}
              />
            </>
          )}
                 {getApplicationType(app) === 'MCP' && (
            <>
              <LabelContent
                title='Frontend Name'
                content={<Label className='!normal-case' text={getFnUrlWithAgentLessCheck()} />}
              />
              <LabelContent
                title='Backend Name'
                content={
                  <Label
                    className='!normal-case'
                    text={_.get(app, McpBackendURLKey) + _.get(app, McpHTTPEntryPathKey, '/')}
                  />
                }
              />
              <LabelContent
                showEmptyLabel
                title='Auth Token'
                content={<Label className='!normal-case' text={_.get(app, McpAuthTokenKey)} />}
              />
              <LabelContent
                title='Mesh Cluster'
                content={<Label className='!normal-case' text={_.get(app, McpMeshClusterKey)} />}
              />
            </>
          )}
          
          <LabelContent
            data-testid={getHTMLDataTestID('app-details', 'label', 'created-on')}
            title='Created On'
            content={moment(app?.ObjectMeta.CreatedAt).format('DD MMMM, YYYY HH:mm:ss A')}
          />
          <LabelContent
            data-testid={getHTMLDataTestID('app-details', 'label', 'last-updated-on')}
            title='Last Updated On'
            content={moment(app?.ObjectMeta.UpdatedAt).format('DD MMMM, YYYY HH:mm:ss A')}
          />
        </div>
      </div>
      {appView === 'admin' && appType === 'MCP' && (
        <div className='w-1/2'>
          {appType === 'MCP' && (
            <>
              <div className='border-[#D8DDE4] border-b pb-4'>
                <Typography variant='h4-regular'>Tools </Typography>
                <div className='flex flex-wrap gap-2 mt-2'>{generateToolsLable(app, 'tools')}</div>
              </div>

              <div className='mt-4 border-[#D8DDE4] border-b pb-4'>
                <Typography variant='h4-regular'>Prompts </Typography>
                <div className='flex flex-wrap gap-2 mt-2'>
                  {generateToolsLable(app, 'prompts')}
                </div>
              </div>

              <div className='mt-4 pb-4'>
                <Typography variant='h4-regular'>Headers </Typography>
                {getHeadersMap(app)}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export { OverviewTab }
